import { httpClient } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";

async function fetchNearbyProducts(location: string) {
  return await httpClient.tasks.get<unknown>(
    `/v1/products/nearby_products?location=${location}`
  );
}

export function useNearbyProducts(location: string) {
  return useQuery({
    queryKey: ["nearby", "products", location],
    queryFn: async () => await fetchNearbyProducts(location),
    staleTime: 0,
    enabled: !!location,
  });
}
